import { CourseResponse, ElementData } from '@app/core/models/courses.model';

export enum CourseTypeEnum {
  Course = 1,
  UC = 2,
}

export interface CourseState {
  course_active: CourseResponse;
  type_active: any;
  element_active: ElementData;
}

export const initialState: CourseState = {
  course_active: undefined,
  type_active: undefined,
  element_active: undefined,
};
